module.exports = __webpack_public_path__ + "img/TRM-labs.30f7bcb3.svg";